module.exports = __webpack_public_path__ + "img/edmbet-support.c2547788.webp";